import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NJDocDefTemplate, NJDocData, NJReadDocDefTemplateLookup, DOData } from '../DOData';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { DOTextBoxComponent } from '../dotext-box/dotext-box.component';
import { DodropDownComponent } from '../dodrop-down/dodrop-down.component';
@Component({
    selector: 'cylib-dropdown-comments',
    templateUrl: './dropdown-comments.component.html',
    styleUrls: ['./dropdown-comments.component.css']
})
export class DropdownCommentsComponent implements OnInit {
    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() public loaderKey: string;
    @Input() skipPostDocDefData: boolean = false;

    @Input() lstDocData: Array<NJDocData> = new Array<NJDocData>();
    @Input() lstChildDocDefTemplate: Array<NJDocDefTemplate>;
    @Input() lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup>;
    @Input() customParameters: any;
    @Input() allowDoubleClick: boolean;

    @Input() isValid: boolean = true;
    @Input() isEnabled: boolean = true;

    @Output() clickBut: EventEmitter<DOData> = new EventEmitter<DOData>();

    public ddTemp: NJDocDefTemplate;
    public txtTemp: NJDocDefTemplate;
    public isTextValid: boolean = true;
    public ddData: NJDocData;
    public txtData: NJDocData;
    public radio: boolean = false;
    public isHidden: boolean = false;
    public hasEvent: boolean = false;
    _isDirty: boolean = false;
    public get isDirty(): boolean {
        if (this.dropDown && this.textBox)
            return this.dropDown.isDirty || this.textBox.isDirty;
        else if (this.textBox)
            return this.textBox.isDirty;
        else if (this.dropDown)
            return this.dropDown.isDirty;
        else return false;
    }
    constructor( ) { }

    ngOnInit() {
        this.radio = this.customParameters['UseDropDownOrRadio'] == 'Radio';
        this.ddTemp = DocDefPrimLibService.createNew(this.lstChildDocDefTemplate[1]);
        this.txtTemp = DocDefPrimLibService.createNew(this.lstChildDocDefTemplate[2]);
        let template = this.lstChildDocDefTemplate.filter(function (item) {
            return item.tType == 'DropDownChild';
        });
        let tmpDdData = (this.lstDocData.filter(function (item) {
            return item.docDefTemplateID == template[0].docDefTemplateID
        }))[0];
        this.ddData = DocDefPrimLibService.createNew(tmpDdData);
        let templateComment = this.setTextValid();
        let tmpTxtData = (this.lstDocData.filter(function (item) {
            return item.docDefTemplateID == templateComment.docDefTemplateID
        }))[0];
        this.txtData = DocDefPrimLibService.createNew(tmpTxtData);
        if (this.customParameters.Hidden)
            this.isHidden = this.customParameters.Hidden == 'Yes';
        if (this.customParameters['hasEvent'] != null) {
            this.hasEvent = true;
        }
    }
    public setTextValid() : NJDocDefTemplate{
        let template = this.lstChildDocDefTemplate.filter(function(item) {
            return item.tType == 'Comments';
        })[0];
        this.isTextValid = template.isValid;//&& this.isValid;
        return template;
    }

    onclickBut(message: DOData) {
        this.clickBut.emit(message);
    }
    onTabEvent(ev: any) {

    }
    textBox: DOTextBoxComponent;
    OnTextAfterViewInit(c: DOTextBoxComponent) {
        this.textBox = c;
    }
    dropDown: DodropDownComponent;
    OnDropDownAfterViewInit(c: DodropDownComponent) {
        this.dropDown = c;
    }
    CallBackWhenClean(ev, component) {
        if (this.dropDown.isDirty)
            this.dropDown.CallBackWhenClean(ev, component)
        else if (this.textBox.isDirty)
            this.textBox.CallBackWhenClean(ev, component)
    }
}
